/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Prev_Error_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Go to previous error" |
*
* @param {Error_Nav_Prev_Error_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_prev_error_aria_label = /** @type {((inputs?: Error_Nav_Prev_Error_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Prev_Error_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a l'erreur precedente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum vorherigen Fehler zurückkehren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'errore precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к предыдущей ошибке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al error anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回上一个错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のエラーへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली त्रुटि पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar ao erro anterior")
	return /** @type {LocalizedString} */ ("Go to previous error")
});